import { render, staticRenderFns } from "./ItemForm.vue?vue&type=template&id=228c139f&"
import script from "./ItemForm.vue?vue&type=script&lang=js&"
export * from "./ItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('228c139f')) {
      api.createRecord('228c139f', component.options)
    } else {
      api.reload('228c139f', component.options)
    }
    module.hot.accept("./ItemForm.vue?vue&type=template&id=228c139f&", function () {
      api.rerender('228c139f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomField/Choice/ItemForm.vue"
export default component.exports